export default () => {
  //cookiebot callbacks
}